import {keepPreviousData, useQuery} from "@tanstack/react-query";
import {useMemo} from "react";

import {useStoredUserProperty} from "@/src/modules/core/store/user-property";
import type {ParamsOptions} from "@/src/modules/core/types";

import {vehiclesService} from "../services";

export default function useVehicle(
  id: number | null,
  options?: ParamsOptions,
) {
  const userProperty = useStoredUserProperty();

  const requestOptions = useMemo((): ParamsOptions | undefined => {
    const fromProperty =
      userProperty?.id != null
        ? {filter: {context_property_id: userProperty.id}}
        : undefined;
    if (!options && !fromProperty) return undefined;
    if (!options) return fromProperty;
    if (!fromProperty) return options;
    return {
      ...options,
      filter: {
        ...(options.filter ?? {}),
        ...fromProperty.filter,
      },
    };
  }, [options, userProperty?.id]);

  const query = useQuery({
    queryKey: [
      "vehicles",
      id,
      userProperty?.id,
      Boolean((requestOptions?.filter as Record<string, unknown> | undefined)?.["with-meta-data"]),
    ],
    queryFn: () => vehiclesService.getVehicle(id!, requestOptions),
    enabled: Boolean(id),
    placeholderData: keepPreviousData,
  });

  const vehicle = id ? (query.data ?? null) : null;
  const isPending = Boolean(id) && query.isPending && vehicle == null;

  return {...query, vehicle, isPending};
}
